import {
  ButtonIcon,
  GridWrapper,
  DeleteActionIcon,
  RoundedIconVisibility,
} from 'components/Ui/styled';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import MDTypography from 'components/MDTypography';
import { ActionWrapperBox } from 'components/Common/common.styled';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const GetTimeBlockHeader = ({ handleNewTimeBlock }) => {
  return (
    <GridWrapper container spacing={2} justifyContent="space-between">
      <Grid item>
        <MDTypography variant="h5" fontWeight="medium">
          Time Blocks Management
        </MDTypography>
      </Grid>

      <Grid item>
        <Button variant="text" onClick={handleNewTimeBlock}>
          New Time Block
        </Button>
      </Grid>
    </GridWrapper>
  );
};

const renderTimeBlocksActions = (params, handleView, handleDelete) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleView(params)}>
        <RoundedIconVisibility />
      </ButtonIcon>
      <ButtonIcon onClick={() => handleDelete(params)}>
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const getTimeBlockV2Columns = (handleView, handleDelete) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: (params) =>
      renderTimeBlocksActions(params, handleView, handleDelete),
  },
  {
    flex: 1,
    field: 'blockType',
    headerName: 'Block Type',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'reason',
    headerName: 'Reason',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    headerName: 'From',
    field: 'startsAt',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'endsAt',
    headerName: 'To',
    renderCell: renderCellExpand,
  },
];

export const getTimeBlockV2ListData = (timeBlockV2ListData) => {
  const items = timeBlockV2ListData?.items;
  if (!items || items.length === 0) {
    return [];
  }

  const formatDateTime = (isoString) =>
    isoString?.replace('T', ' ').slice(0, 16);

  return items.map(
    ({
      reason,
      endsAt,
      startsAt,
      teacherId,
      subjectId,
      blockType,
      timeBlockId,
      cancelledSessionIds,
      reassignedSessionIds,
    }) => ({
      reason,
      teacherId,
      subjectId,
      blockType,
      timeBlockId,
      id: timeBlockId,
      cancelledSessionIds,
      reassignedSessionIds,
      endsAt: formatDateTime(endsAt),
      startsAt: formatDateTime(startsAt),
    }),
  );
};

export const TimeBlockFilters = ({
  control,
  teachers,
  subjects,
  booleanOptions,
  onClear,
}) => {
  return (
    <GridWrapper container spacing={2}>
      <Grid item xs={12} md={3}>
        <FormInputDropdown
          filter
          name="teacher"
          label="Teacher"
          control={control}
          options={teachers}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <FormInputDropdown
          filter
          name="subject"
          label="Subject"
          control={control}
          options={subjects}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FormInputDropdown
          name="activeOnly"
          control={control}
          label="Active Only"
          options={booleanOptions}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FormInputDropdown
          name="ascending"
          label="Ascending"
          control={control}
          options={booleanOptions}
        />
      </Grid>

      <Grid item xs={12} md={2} textAlign="right">
        <Button variant="text" onClick={onClear}>
          Clear Filters
        </Button>
      </Grid>
    </GridWrapper>
  );
};
